import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import PrivateRoutes from './utils/PrivateRoutes';
import { AuthProvider } from './context/authContext';
import Layout from './utils/Layout';
import WebsiteRoutes from './routes/WebsiteRoutes';

function App() {
  return (
    <div className="main-app">
      <BrowserRouter>
        <AuthProvider>
          
          <Routes>
            <Route path="/portal/*" element={<PrivateRoutes  component={Layout} />} />
            <Route path="/*" element={<WebsiteRoutes />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={6608}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        />
      
    </div>
  );
}

export default App;
